var XMLNode = require('../xml/XMLNode');

/**
 * The SharedString class represents each shared String within the
 * SharedStrings file.
 *
 * @param {string} sValue - The String that gets represented by this SharedString object
 * @class
 */
function SharedString(sValue) {
	XMLNode.call(this, SharedString.metadata);

	this.setValue(sValue);
}

SharedString.prototype = Object.create(XMLNode.prototype);
SharedString.prototype.constructor = SharedString;

SharedString.formulaRegex = /^[=+-@](cmd|hyperlink).+$/gi;

SharedString.metadata = {
	tag: 'si',
	properties: [
		{
			id: 'text',
			tag: 't'
		}
	]
};

/**
 * Assigns the given value to the current SharedString instance.
 *
 * @function
 * @param {string} sValue - The string value that should be added
 */
SharedString.prototype.setValue = function(sValue) {

	/* Escape possible formula injection exploit */
	sValue = SharedString.formulaRegex.test(sValue) ? '\'' + sValue : sValue;

	if (sValue && typeof sValue == 'string') {
		this.text.value = sValue;
	} else {

		/**
		 * There are other implementations for creating a string
		 * representation out of a number that might be more
		 * convenient like new String(number).toString() or
		 * number.toString() but '' + number is the best performing.
		 */
		this.text.value = '' + sValue;
	}
};

/**
 * Serializes the XMLNode and transforms the concatenated string into a sequential string.
 * @return {string} - String representation of the SharedString
 *
 * @override
 */
SharedString.prototype.serialize = function() {
	var sSerialized;

	sSerialized = Object.getPrototypeOf(SharedString.prototype).serialize.call(this);

	return (' ' + sSerialized).substr(1);
};

module.exports = SharedString;


//////////////////
// WEBPACK FOOTER
// ./core/xlsx/src/data/SharedString.js
// module id = 24
// module chunks = 0